import { Button, IconButton, Tooltip } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import * as React from "react";
import { VarPartnerLevels, VarPreferredPartnerLevel, VarRegisteredPartnerLevel } from '../../codec/varInDTODecoder';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import BadgeIconCustom from '../CustomIcons/BadgeIconCustom';
import NewspaperIconCustom from '../CustomIcons/NewspaperIconCustom';
import Permission from '../Permission/Permission';
import ReduxLanguage from '../ReduxLanguage';
import { InfoOutlined } from '@material-ui/icons';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});


export interface IVarPartnerLevelState {
}

export interface IVarPartnerLevelProps extends WithStyles<typeof styles>{
  activeBadgesIndexes: number[];
  onOpenVarCertificate: () => void | undefined;
}

class VarPartnerLevel extends React.Component<IVarPartnerLevelProps, IVarPartnerLevelState> {
  

  public render() {
    const { activeBadgesIndexes, onOpenVarCertificate } = this.props;
    const registeredPartnerLevel = VarRegisteredPartnerLevel;
    const preferredPartnerLevel = VarPreferredPartnerLevel;
    const currentVarLevel = _.size(activeBadgesIndexes);
    const currentStepsAway = preferredPartnerLevel - currentVarLevel;
    const hasContractSigned = activeBadgesIndexes.includes(0);
    
    return (
      <div style={{background: '#fff', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', padding: 24, display: 'flex', flexDirection: 'column'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexGrow: 1, justifyContent: 'space-between' }}>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10, flexGrow: 1}}>
            <div style={{fontSize: 18, fontWeight: 600, color: '#888', marginBottom: 8, letterSpacing: 1, width: 'max-content', backgroundColor: '#eee', 
              padding: 6, marginLeft: '-24px', paddingLeft: '24px'}}>
              {!hasContractSigned ? 'CANDIDATE VAR' : currentVarLevel >= preferredPartnerLevel ? 'PREFERRED PARTNER' : currentVarLevel >= registeredPartnerLevel ? 'REGISTERED PARTNER' : 'CANDIDATE VAR'}
            </div>
            {onOpenVarCertificate ? (
                <Permission abilityHelper={AbilityProvider.getAbilityHelper()} permission={PERMISSIONS.VAR_DOWNLOAD_CERTIFICATE}>
                  <Tooltip title={<ReduxLanguage languageKey="vars.downloadCertificate" />} placement="left" arrow>
                    <IconButton onClick={() => onOpenVarCertificate()} style={{ marginBottom: 5 }}>
                      <NewspaperIconCustom className="" style={{ color: 'darkcyan', width: 20 }} />
                    </IconButton>
                  </Tooltip>
                </Permission>
              ) : null}
            </div>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <InfoOutlined style={{ color: '#3f3f3f', fontSize: 20, marginRight: 10 }} />
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <span style={{fontWeight: 600, fontSize: 15, color: '#3f3f3f', marginBottom: 4, marginTop: 0}}>
                  {!hasContractSigned ? 
                    <ReduxLanguage languageKey="vars.candidatePartnerStepsAway" /> :
                    currentVarLevel >= preferredPartnerLevel ? 
                    <ReduxLanguage languageKey="vars.preferredPartner" /> :
                    currentVarLevel >= registeredPartnerLevel ?
                    <ReduxLanguage languageKey="vars.preferredPartnerStepsAway" languageProps={{ steps: currentStepsAway }} /> :
                    <ReduxLanguage languageKey="vars.candidatePartnerStepsAway" />
                  }
                </span>
                <span style={{ fontSize: 11, color: '#888', marginBottom: 0, marginTop: 0 }}>
                  {!hasContractSigned ?
                    <ReduxLanguage languageKey="vars.candidatePartnerStepsAwayDescription" /> :
                    currentVarLevel >= preferredPartnerLevel ?
                    <ReduxLanguage languageKey="vars.preferredPartnerDescription" /> :
                    currentVarLevel >= registeredPartnerLevel ?
                    <ReduxLanguage languageKey="vars.preferredPartnerStepsAwayDescription" languageProps={{ steps: currentStepsAway }} /> :
                    <ReduxLanguage languageKey="vars.candidatePartnerStepsAwayDescription" />
                  }
                </span>
              </div>
            </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', marginTop: 20 }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 32 }}>
            {VarPartnerLevels.map((step, idx) => (
              <div key={step.id} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: 90}}>
                {activeBadgesIndexes.includes(idx) ? <BadgeIconCustom className="" style={{color: '#FFD700', width: 36}} /> : <BadgeIconCustom className="" style={{color: '#D3D3D3', width: 36}} />}
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 32 }}>
            {VarPartnerLevels.map((step, idx) => (
              <div key={step.id} style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: 90}}>
                <div style={{fontSize: 13, color: activeBadgesIndexes.includes(idx) ? '#222' : '#888', fontWeight: activeBadgesIndexes.includes(idx) ? 500 : 400, marginTop: 4, textAlign: 'center'}}>
                  <ReduxLanguage languageKey={`vars.${step.label}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <span style={{flexGrow: 1}} />
      </div>
    );
  }
}

export default withStyles(styles)(VarPartnerLevel);